import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { QuestionOptionSubOptions } from "./sub-options";
import { useSubOptions } from "./sub-options/hooks";
import { QuestionOptionUseAsSubOption } from "./use-as-sub-option";
import { useOptionUseAsSubOption } from "./use-as-sub-option/hooks";

export const QuestionOptionSubOptionSettings = () => {
	const {
		useAsSubOption,
		onSetUseAsSubOption,

		isEdited: isEdited_useAsSubOption,
		hasError: hasError_useAsSubOption,
	} = useOptionUseAsSubOption();

	const {
		subOptions,
		appendSubOption,
		removeSubOption,
		onSetSubOptionName,
		onSetIsNextMorning,
		onSetIsShowTimeSchedule,
		onSetStartAt,
		onSetEndAt,
		onSetMaxDailyStockNum,
		onSetPriceAmount,
		onUpdateOrderSubOptions,
	} = useSubOptions();

	const shouldShowDetailSettings = useAsSubOption.value;

	const title = "サブオプションの設定";
	const guide =
		"オプションに複数の選択肢を与えることができます。<br /><br />サブオプションはそれぞれ個別に在庫管理が可能ですが、合計在庫数がオプション全体の在庫数を超えないように設定されています。 時間帯がある場合は、開始時刻と終了時刻を入力してください。 また、終了時刻が日を跨ぐ場合は24以降の数字で指定してください。<br /><br />入力例）午前第一部、昼食(並)";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			guide={guide}
			isEdited={isEdited_useAsSubOption}
			hasError={hasError_useAsSubOption}
			inputChildren={
				<div className="grid gap-5">
					<QuestionOptionUseAsSubOption
						useAsSubOption={useAsSubOption}
						onSetUseAsSubOption={onSetUseAsSubOption}
					/>

					{shouldShowDetailSettings && (
						<QuestionOptionSubOptions
							subOptions={subOptions}
							appendSubOption={appendSubOption}
							removeSubOption={removeSubOption}
							onSetSubOptionName={onSetSubOptionName}
							onSetIsNextMorning={onSetIsNextMorning}
							onSetIsShowTimeSchedule={onSetIsShowTimeSchedule}
							onSetStartAt={onSetStartAt}
							onSetEndAt={onSetEndAt}
							onSetMaxDailyStockNum={onSetMaxDailyStockNum}
							onSetPriceAmount={onSetPriceAmount}
							onUpdateOrderSubOptions={onUpdateOrderSubOptions}
						/>
					)}
				</div>
			}
		/>
	);
};

QuestionOptionSubOptionSettings.displayName = "QuestionOptionSubOptionSettings";
